export default __webpack_public_path__ + "static/media/ctu.27c4451a.png";